export const FETCH_STATES_REQUEST = 'FETCH_STATES_REQUEST'
export const FETCH_STATES_SUCCESS = 'FETCH_STATES_SUCCESS'
export const FETCH_STATES_FALIURE = 'FETCH_STATES_FALIURE'
